import { Breadcrumb, Tabs } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../../address";
import styles from "./assignKitToDealer.module.scss";
import NewRequestList from "./newRequestList";
import CompletedRequests from "./completedRequests";
import AssignedToMe from "./assignedToMe";

const AssignKitToDealer = () => {
	return (
		<div className="container-main container-cw">
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[
							{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest, title: "مدیریت کیت سیم‌کارت" },
							{ title: "تخصیص کیت به نماینده" },
						]}
					/>
					<div className="title-page">
						<h3>تخصیص کیت به نماینده</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className={styles.holder_assign_kit}>
							<Tabs
								rootClassName={styles.customtab}
								defaultActiveKey="new_request"
								items={[
									{
										key: "new_request",
										label: "درخواست جدید",
										children: <NewRequestList />,
									},
									{
										key: "completed_requests",
										label: "درخواست‌های انجام شده",
										children: <CompletedRequests />,
									},
									{
										key: "assigned_to_me",
										label: "کیت های تخصیصی به من",
										children: <AssignedToMe />,
									},
								]}
							/>
						</div>
					</div>
				</Content>
			</div>
		</div>
	);
};

export default AssignKitToDealer;
